import { RecipeResult } from "../../../../api/recipeResults";
import { createProcessPatternColor } from "../../../../utils/recipeColor.utill";
import { BREAKDOWN_TYPE, CHART_COLOR, CHART_LABEL } from "../recipeImpactChart.constants";
import { BreakdownItem, ChartVariant } from "../recipeImpactChart.types";
import { findImpactForItem } from "../utils/breakdownItem.utill";

/** One stacked bar series per breakdown item, with process bars striped. */
export const buildBreakdownSeries = (
  items: BreakdownItem[],
  variants: ChartVariant[],
  colorById: Record<string, string>,
  patternIndexById: Record<string, number> = {}
) => {
  return items.map(item => {
    const isProcess = item.type === BREAKDOWN_TYPE.process;
    const color = isProcess
      ? createProcessPatternColor(colorById[item.id], patternIndexById[item.id] ?? 0)
      : colorById[item.id];

    return {
      name: item.name || CHART_LABEL.unknown,
      type: "bar",
      stack: "total",
      emphasis: { focus: "series" },
      itemStyle: { color },
      data: variants.map(variant => findImpactForItem(variant.breakdown, item))
    };
  });
};

/** Total climate impact per chart column, used by the floating total label. */
export const buildTotalImpacts = (
  variants: ChartVariant[],
  recipeResults: RecipeResult | undefined
): number[] =>
  variants.map(variant => {
    if (variant.variantName === CHART_LABEL.baseline) {
      return recipeResults?.originalRecipetotalImpacts?.climateChange?.measure || 0;
    }
    const match = recipeResults?.variantstotalImpacts.find(
      candidate => candidate.variantName.trim() === variant.variantName
    );
    return match?.totalImpacts?.climateChange?.measure ?? 0;
  });

/** A transparent series whose only job is to render the total impact label. */
export const buildTotalImpactSeries = (totalImpacts: number[]) => ({
  name: CHART_LABEL.totalImpact,
  type: "bar",
  itemStyle: { color: CHART_COLOR.transparent },
  label: {
    show: true,
    position: "top",
    formatter: (params: any) => `${params.value.toFixed(2)}`,
    fontWeight: "semi-bold",
    color: CHART_COLOR.totalLabel
  },
  emphasis: { disabled: true },
  tooltip: { show: false },
  barGap: "-100%",
  z: 5,
  data: totalImpacts
});
